<div class="flex mb-3">
  <p-iconField iconPosition="left">
    <p-inputIcon styleClass="fas fa-search" />
    <input
      class="w-20rem"
      pInputText
      #searchQuery
      (keyup)="updateList(searchQuery.value)"
      placeholder="durchsuchen ..." />
  </p-iconField>
</div>
<p-accordion *ngIf="itemsFiltered.length">
  @for (item of itemsFiltered; track item.key) {
    <p-accordionTab>
      <ng-template pTemplate="header">
        <div class="flex gap-3">
          <i *ngIf="icon" [class]="icon"></i>
          {{ item.name }}
        </div>
      </ng-template>

      <div class="p-datatable">
        <table class="p-datatable-table w-full">
          <tbody class="p-datatable-tbody">
            <tr>
              <td><strong>Schlüssel</strong></td>
              <td>{{ item.key }}</td>
            </tr>
            <tr>
              <td><strong>Name</strong></td>
              <td>{{ item.name }}</td>
            </tr>
            <tr>
              <td><strong>Beschreibung</strong></td>
              <td [innerHTML]="item.description"></td>
            </tr>
            <tr>
              <td><strong>Koordinaten</strong></td>
              <td>{{ item.geoPositionX }} | {{ item.geoPositionY }}</td>
            </tr>
            <tr>
              <td><strong>Adresse</strong></td>
              <td>{{ item.address }}</td>
            </tr>
            <tr>
              <td><strong>Informationen</strong></td>
              <td [innerHTML]="item.information"></td>
            </tr>
            <tr>
              <td><strong>Kontakt</strong></td>
              <td [innerHTML]="item.contact"></td>
            </tr>
          </tbody>
        </table>
      </div>
    </p-accordionTab>
  }
</p-accordion>
